<template>
  <fieldset class="plan-select">
    <div
      v-for="(plan, index) in plans[active.plan].duration"
      :key="index"
      class="plan-select-item"
    >
      <label
        :class="active.period === index ? 'plan-select-label selected' : 'plan-select-label'"
      >
        <input
          v-model="value"
          :value="index"
          class="plan-select-input"
          type="radio"
          @change="updateValue"
        >
        <span class="plan-select-text">
          {{ plan.name }} {{ plan.save ? `(Save ${plan.save}%)` : null }}
        </span>
      </label>
    </div>
  </fieldset>
</template>

<script>
import {mapMutations, mapState} from 'vuex'
export default {
  name: 'PlanSelect',
  data () {
    return {
      value: 0
    }
  },
  computed: {
    ...mapState('subscription', {
      plans: state => state.plans,
      active: state => state.active,
      premiumFeatures: state => state.premiumFeatures
    })
  },
  methods: {
    ...mapMutations('subscription', {
      SET_PERIOD: 'SET_PERIOD'
    }),
    updateValue (index) {
      const val = Number(index.target.value)
      this.SET_PERIOD(val)
    }
  }
}
</script>

<style>
fieldset.plan-select {
  position: relative;
  display: flex;
  border-radius: 9999px;
  padding: 0.1875rem;
  border: 1px solid #FFFFFF;
  background: linear-gradient(to bottom, #FFFFFF, #E6E6E6);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
}

.plan-select-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
}

.plan-select-label {
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  width: 100%;
  border-radius: 9999px;
  height: 34px;
  margin: 0;
  padding-left: 1rem;
  padding-right: 1rem;
  color: #637288;
  text-align: center;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.plan-select-label.selected {
  color: #FFFFFF !important;
  background: linear-gradient(to bottom, #A0DF64, #63AE63);
}

.plan-select-input {
  pointer-events: none;
  position: absolute;
  opacity: 0;
  height: 0;
  width: 0;
}

.plan-select-text {
  font-size: 0.75rem;
  line-height: 1;
  font-weight: 700;
  font-family: ProximaNova;
}
</style>